<template>
  <div>
    <Card style="width: 100%; margin-bottom: 20px" class="card">
      <Form :model="modalFormItem" :label-width="100" label-position="left">
        <Row :gutter="20">
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('PB_Meeting_Status')"
              ><!-- 会议状态 -->
              <Tag :color="beEndNameColor(rowItem.beEndName)">{{
                lang == "zh" ? rowItem.beEndName : rowItem.beEnEndName
              }}</Tag>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Meeting_Subjects')"
              ><!-- 会议名称 -->
              <Input v-model="rowItem.meetingName" disabled />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Meeting_Date')"
              ><!-- 会议时间 -->
              <DatePicker
                type="date"
                v-model="rowItem.meetingDate"
                :transfer="true"
                disabled=""
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Meeting_Type')"
              ><!-- 会议类型 -->
              <Select v-model="rowItem.meetingType" disabled transfer>
                <Option
                  v-for="item in meetingTypeList"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>
    <Tabs :animated="false" type="card" v-if="btnShow">
      <TabPane :label="$t('PB_Successors_User')"
        ><!-- 继任盘点员工 -->
        <Form :model="modalFormItem" :label-width="100" label-position="left">
          <Row :gutter="20">
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('BU')"
                ><!-- 业务单元 -->
                <Select
                  v-model="modalFormItem.businessUnit"
                  clearable
                  style="width: 100%"
                >
                  <Option
                    v-for="item in businessUnitList"
                    :value="item.ch_value"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Department')"
                ><!-- 大区 -->
                <Select
                  v-model="modalFormItem.department"
                  clearable
                  style="width: 100%"
                >
                  <Option
                    v-for="item in departmentList"
                    :value="item.ch_value"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Funciton')"
                ><!-- 职能 -->
                <Select
                  v-model="modalFormItem.postFun"
                  clearable
                  style="width: 100%"
                >
                  <Option
                    v-for="item in functionList"
                    :value="item.ch_value"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Management_Level')"
                ><!-- 管理层级 -->
                <Select
                  v-model="modalFormItem.hrmanage"
                  clearable
                  style="width: 100%"
                >
                  <Option
                    v-for="item in ManagementLevel"
                    :value="item.ch_value"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Position')"
                ><!-- 职位 -->
                <Input v-model="modalFormItem.position" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Employee_Code')"
                ><!-- 员工号 -->
                <Input type="text" v-model="modalFormItem.empCode" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Name')"
                ><!-- 姓名 -->
                <Input type="text" v-model="modalFormItem.userName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('English_Name')"
                ><!-- 英文名 -->
                <Input type="text" v-model="modalFormItem.userEName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Line_Manager')"
                ><!-- 直接上级 -->
                <Input
                  type="text"
                  v-model="modalFormItem.dirSupName"
                  search
                  enter-button
                  clearable
                  readonly
                  @on-clear="dirClear()"
                  @on-search="dirSearch"
                />
              </FormItem>
              <p
                style="
                  font-size: 12px;
                  color: red;
                  margin-top: -15px;
                  margin-bottom: 10px;
                "
              >
                {{ $t("PB_longText31")
                }}<!-- *默认显示选择人员的所有下属，如需进一步筛选，请选择汇报层级 -->
              </p>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Reporting_Line')"
                ><!-- 汇报层级 -->
                <Select
                  v-model="modalFormItem.levelNum"
                  multiple
                  clearable
                  :disabled="levelDisabledState"
                >
                  <Option
                    v-for="item in Level"
                    :value="item.code"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Carlsberg_Band')"
                ><!-- 嘉士伯级别 -->
                <Select
                  v-model="modalFormItem.hcmBand"
                  clearable
                  style="width: 100%"
                >
                  <Option
                    v-for="item in Band"
                    :value="item.ch_value"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="6"
              v-if="targetkey == 'assessedList' || targetkey == 'successorList'"
            >
              <FormItem :label="$t('PB_Employment_Status')"
                ><!-- 在职状态 -->
                <Select
                  v-model="modalFormItem.beQuit"
                  clearable
                  style="width: 100%"
                >
                  <Option
                    v-for="item in BeQuit"
                    :value="item.code"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('PersonelType2')"
                ><!-- personneltype2 -->
                <Select v-model="modalFormItem.personnelType" clearable>
                  <Option
                    v-for="item in personnelType"
                    :value="item.code"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="this.$t('GroupSelect')">
                <UserGroupList
                  ref="UserGroupList"
                  @confirmSelectGroup="confirmSelectGroup"
                ></UserGroupList>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="4">
              <Button @click="(pageInfo.pageNo = 1), getData()"
                ><!-- 检 索 -->{{ $t("Be_Select_Emp") }}</Button
              >
              <Button @click="handleReset()"
                ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
              >
            </Col>
          </Row>
        </Form>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <div>
            <span><!-- 合计： -->{{ $t("PB_Total") }}:{{ total }}</span>
            <!-- <span style="margin-left:20px" v-if="btnShow">空岗合计：{{nullJobNum}}个</span> -->
          </div>
          <div>
            <Button
              :disabled="
                (rowItem.beEnd == 1 || rowItem.beEnd == 4 || hostState) &&
                targetkey != 'authorizeList'
              "
              type="text"
              @click="addPerson"
              ><!-- 新增人员 -->{{ $t("PB_Select_Employee") }}</Button
            >
            <Button style="margin-left: 10px" type="text" @click="handleConfirm"
              ><!-- 保存并返回 -->{{ $t("Save_and_Return") }}</Button
            >
            <!-- <Button v-if="btnShow" :disabled="rowItem.beEnd==1" type="text" @click="addJob">新增空岗</Button>  -->
          </div>
        </div>
        <Table
          border
          :columns="modelColumns"
          :data="modelData"
          ref="selectiona"
          :loading="loading"
          :max-height="tableheight"
        >
          <template slot="action1" slot-scope="{ row, index }">
            <Button
              type="error"
              size="small"
              :disabled="
                (rowItem.beEnd == 1 || rowItem.beEnd == 4 || hostState) &&
                targetkey != 'authorizeList'
              "
              @click="deleteItem(row, index)"
              ><!-- 删除 -->{{ $t("Delete") }}</Button
            >
          </template>
        </Table>

        <div style="display: flex; justify-content: end; margin-top: 30px">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            transfer
            :page-size-opts="[10, 50, 100, 150]"
            show-sizer
            @on-page-size-change="pageSizeChange"
            :current="pageInfo.pageNo"
            @on-change="pageChange"
          ></Page>
        </div>
      </TabPane>
      <TabPane :label="$t('PB_Vacancy')"><PDJob ref="PDJob"></PDJob></TabPane
      ><!-- 继任盘点空岗 -->
    </Tabs>
    <div v-if="!btnShow">
      <Form :model="modalFormItem" :label-width="100" label-position="left">
        <Row :gutter="20">
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('BU')"
              ><!-- 业务单元 -->
              <Select
                v-model="modalFormItem.businessUnit"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in businessUnitList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Department')"
              ><!-- 大区 -->
              <Select
                v-model="modalFormItem.department"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in departmentList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Funciton')"
              ><!-- 职能 -->
              <Select
                v-model="modalFormItem.postFun"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in functionList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Management_Level')"
              ><!-- 管理层级 -->
              <Select
                v-model="modalFormItem.hrmanage"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in ManagementLevel"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="this.$t('DepartmentSalesRegion')"
              ><!-- 部门/销售区域 -->
              <Select v-model="modalFormItem.salesArea" clearable>
                <Option
                  v-for="item in salesAreaList"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Position')"
              ><!-- 职位 -->
              <Input v-model="modalFormItem.position" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Employee_Code')"
              ><!-- 员工号 -->
              <Input type="text" v-model="modalFormItem.empCode" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Name')"
              ><!-- 姓名 -->
              <Input type="text" v-model="modalFormItem.userName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('English_Name')"
              ><!-- 英文名 -->
              <Input type="text" v-model="modalFormItem.userEName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Line_Manager')"
              ><!-- 直接上级 -->
              <Input
                type="text"
                v-model="modalFormItem.dirSupName"
                search
                enter-button
                clearable
                readonly
                @on-clear="dirClear()"
                @on-search="dirSearch"
              />
            </FormItem>
            <p
              style="
                font-size: 12px;
                color: red;
                margin-top: -15px;
                margin-bottom: 10px;
              "
            >
              {{ $t("PB_longText31")
              }}<!-- *默认显示选择人员的所有下属，如需进一步筛选，请选择汇报层级 -->
            </p>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Reporting_Line')"
              ><!-- 汇报层级 -->
              <Select
                v-model="modalFormItem.levelNum"
                multiple
                clearable
                :disabled="levelDisabledState"
              >
                <Option
                  v-for="item in Level"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Carlsberg_Band')"
              ><!-- 嘉士伯级别 -->
              <Select
                v-model="modalFormItem.hcmBand"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in Band"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('IsNotSTIEmp')"
              ><!-- 是否有STI -->
              <Select v-model="modalFormItem.perresult" clearable>
                <Option
                  v-for="item in YesOrNo"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="6"
            v-if="targetkey == 'assessedList' || targetkey == 'successorList'"
          >
            <FormItem :label="$t('PB_Employment_Status')"
              ><!-- 在职状态 -->
              <Select
                v-model="modalFormItem.beQuit"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in BeQuit"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('PersonelType2')"
              ><!-- personneltype2 -->
              <Select v-model="modalFormItem.personnelType" clearable>
                <Option
                  v-for="item in personnelType"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="this.$t('GroupSelect')">
              <UserGroupList
                ref="UserGroupList"
                @confirmSelectGroup="confirmSelectGroup"
              ></UserGroupList>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <div
              style="
                display: flex;
                justify-content: flex-end;
                margin-bottom: 15px;
              "
            >
              <Button @click="(pageInfo.pageNo = 1), getData()"
                ><!-- 检 索 -->{{ $t("Be_Select_Emp") }}</Button
              >
              <Button style="margin-left: 10px" @click="handleReset()"
                ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        "
      >
        <div>
          <span><!-- 合计： -->{{ $t("PB_Total") }}:{{ total }}</span>
        </div>
        <div>
          <Button
            :disabled="
              (rowItem.beEnd == 1 || rowItem.beEnd == 4 || hostState) &&
              targetkey != 'authorizeList'
            "
            type="text"
            @click="addPerson"
            ><!-- 新增人员 -->{{ $t("PB_Select_Employee") }}</Button
          >
          <Button style="margin-left: 10px" type="text" @click="handleConfirm"
            ><!-- 保存并返回 -->{{ $t("Save_and_Return") }}</Button
          >
        </div>
      </div>
      <Table
        border
        :columns="modelColumns"
        :data="modelData"
        ref="selectiona"
        :loading="loading"
        :max-height="tableheight"
      >
        <template slot="action1" slot-scope="{ row, index }">
          <Button
            type="error"
            size="small"
            :disabled="
              (rowItem.beEnd == 1 || rowItem.beEnd == 4 || hostState) &&
              targetkey != 'authorizeList'
            "
            @click="deleteItem(row, index)"
            ><!-- 删除 -->{{ $t("Delete") }}</Button
          >
        </template>
      </Table>

      <div style="display: flex; justify-content: end; margin-top: 30px">
        <Page
          :total="total"
          :page-size="pageInfo.pageSize"
          transfer
          :page-size-opts="[10, 50, 100, 150]"
          show-sizer
          @on-page-size-change="pageSizeChange"
          :current="pageInfo.pageNo"
          @on-change="pageChange"
        ></Page>
      </div>
    </div>

    <div class="footer">
      <Button type="text" @click="handleConfirm"
        ><!-- 保存并返回 -->{{ $t("Save_and_Return") }}</Button
      >
    </div>
    <Modal v-model="sessionModal" :title="$t('Selected_Appraisee')" width="40%"
      ><!-- 已选择的被评估员工 -->
      <Table
        border
        size="small"
        :columns="modalColumnsA"
        :loading="sessionLoading"
        :data="sessionData"
        style="margin: 20px 0"
      ></Table>
      <div style="display: flex; justify-content: space-between; width: 100%">
        <div style="color: red">{{ $t("peopleboardRemind") }}</div>
        <Page :total="total1" @on-change="pageChange1" />
      </div>

      <div slot="footer">
        <Button @click="sessionModal = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
        <Button @click="ConfirmSelect"><!-- 取消 -->{{ $t("Confirm") }}</Button>
      </div>
    </Modal>
    <JobModal ref="JobModal" @jobSave="jobSave"></JobModal>
    <DirModalComponent
      ref="DirModalComponent"
      @selectRow="dirSelect"
    ></DirModalComponent>
    <selectPeopleVue
      ref="peoModal"
      @onSelectList="onSelectList"
      @peoSave="peoSave"
    />
  </div>
</template>

<script>
import axios from "axios";
import EventBus from "@/util/eventBus.js";
import JobModal from "./JobModal";
import selectPeopleVue from "./PDselectPeople.vue";
import PDJob from "./PDJob";
import DirModalComponent from "../components/modalComponents/DirModalComponent.vue";
import UserGroupList from "../components/UserGroupList.vue";
export default {
  components: {
    JobModal,
    DirModalComponent,
    selectPeopleVue,
    PDJob,
    UserGroupList,
  },
  data() {
    return {
      loading: false,
      modal: false,
      modalFormItem: {
        dirSupName: "",
        levelNum: [],
      },
      modelData: [],
      YesOrNo: [],
      salesAreaList: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 150,
      },
      total: 0,
      list: [],
      positionList: [],
      ApplyStatus: [],
      departmentList: [],
      functionList: [],
      businessUnitList: [],
      Level: [],
      ManagementLevel: [],
      BeQuit: [],
      meetingTypeList: [],
      selectList: [],
      Band: [],
      state: false,
      rowItem: {},
      targetkey: "",
      userType: "",
      id: "",
      nullJobNum: 0,
      btnShow: false,
      beEnd: "",
      personNum: 0,
      levelDisabledState: true,
      searchState: false,
      sessionModal: false,
      sessionData: [],
      total1: 0,
      pageInfo1: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      sessionLoading: false,
      hostState: true,
      tableheight: 0,
      personnelType: [],
    };
  },
  watch: {
    "$i18n.locale"(newValue) {
      this.$nextTick(() => {
        if (this.$route.query.userType == 1) {
          this.$store.state.current.pageInfo.pageInfo.pageName =
            this.$t("PB_Appraisee"); /* 被评估人员 */
        } else if (this.$route.query.userType == 2) {
          this.$store.state.current.pageInfo.pageInfo.pageName =
            this.$t("PB_Attendees"); /* 参会人员 */
        } else if (this.$route.query.userType == 3) {
          this.$store.state.current.pageInfo.pageInfo.pageName = this.$t(
            "PB_Authorised_Person"
          ); /* 授权人员 */
        } else {
          this.$store.state.current.pageInfo.pageInfo.pageName =
            this.$t("PB_Successors"); /* 继任盘点对象 */
        }
      });
    },
  },
  computed: {
    modelColumns() {
      return [
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Department") /* 大区 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Funciton") /* 职能 */,
          key: this.lang == "zh" ? "postFun" : "enPostFun",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "positionCTitle",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Hire_Date") /* 入职日期 */,
          key: "hireDate",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action1",
          align: "center",
          minWidth: 100,
          fixed: "right",
        },
      ];
    },
    modalColumnsA() {
      return [
        {
          title: this.$t("employee_type") /* 员工类型 */,
          key: "peopleType",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Name"),
          key: "userName",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("PB_Meeting_Owner") /* 会议管理员 */,
          key: "talentUserName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Meeting_Subjects") /* 会议名称 */,
          key: "meetingName",
          align: "center",
          minWidth: 160,
        },
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  mounted() {
    this.tableheight = window.innerHeight - 200;
    window.onresize = () => {
      return (() => {
        this.tableheight = window.innerHeight - 200;
      })();
    };
  },
  created() {
    this.$store.state.current.pageInfo.pageInfo.pageAddon = {};
    this.userType = this.$route.query.userType;
    this.id = this.$route.query.id;
    this.$route.query.btnShow == "false"
      ? (this.btnShow = false)
      : (this.btnShow = true);
    this.targetkey = this.$route.query.targetkey;
    this.getListData();
    this.getData();
    if (this.$route.query.userType == 1) {
      this.$store.state.current.pageInfo.pageInfo.pageName =
        this.$t("PB_Appraisee"); /* 被评估人员 */
    } else if (this.$route.query.userType == 2) {
      this.$store.state.current.pageInfo.pageInfo.pageName =
        this.$t("PB_Attendees"); /* 参会人员 */
    } else if (this.$route.query.userType == 3) {
      this.$store.state.current.pageInfo.pageInfo.pageName = this.$t(
        "PB_Authorised_Person"
      ); /* 授权人员 */
    } else {
      this.$store.state.current.pageInfo.pageInfo.pageName =
        this.$t("PB_Successors"); /* 继任盘点对象 */
      this.$nextTick(() => {
        this.$refs.PDJob.id = this.id;
        this.$refs.PDJob.beEnd = this.rowItem.beEnd;

        this.$refs.PDJob.getData();
      });
    }
  },
  methods: {
    ConfirmSelect() {
      this.$Modal.confirm({
        title: "确认操作？",
        onOk: () => {
          this.sessionModal = false;
          this.$refs.peoModal.saveTwo();
        },
      });
    },
    // 组选择
    confirmSelectGroup(list) {
      this.modalFormItem.userGroupList = JSON.parse(JSON.stringify(list));
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.positionList = res.positionList;
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
          this.Level = res.Level;
          this.Band = res.Band;
          this.YesOrNo = res.YesOrNo;
          this.salesAreaList = res.salesAreaList;
          this.functionList = res.functionList;
          this.BeQuit = res.BeQuit;
          this.ManagementLevel = res.ManagementLevel;
          this.meetingTypeList = res.MeetingType;
          this.personnelType = res.personnelType;
        }
      });
    },
    getData() {
      let obj = {
        userType: this.userType,
        id: this.id,
        ...this.modalFormItem,
        ...this.pageInfo,
      };
      this.loading = true;
      axios
        .post("/TalentInventory/selectPeoPleBoardPerson", obj)
        .then((res) => {
          this.loading = false;
          if (res) {
            this.modelData = res.data;
            this.rowItem = res.meetingData;

            this.nullJobNum = res.nullJobNum;
            this.total = parseInt(res.pageInfo.total);
            if (
              res.meetingData.hostId ==
              JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            ) {
              this.hostState = false;
              this.$route.query.userType == 4
                ? (this.$refs.PDJob.beEnd = this.rowItem.beEnd)
                : "";
            } else {
              this.hostState = true;
              this.$route.query.userType == 4
                ? (this.$refs.PDJob.beEnd = 1)
                : "";
            }
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    handleConfirm() {
      this.$router.back();
    },
    addPerson() {
      let obj = {
        userType: this.userType,
        id: this.id,
        pageSize: 99999,
        pageNo: 1,
      };
      axios
        .post("/TalentInventory/selectPeoPleBoardPerson", obj)
        .then((res) => {
          if (res) {
            let modelData = res.data;
            modelData.length > 0
              ? (this.$refs.peoModal.selectList = [...modelData])
              : "";
          }
        });
      this.$refs.peoModal.modal = true;
      this.$refs.peoModal.id = this.id;
      this.$refs.peoModal.targetkey = this.targetkey;
      this.$refs.peoModal.rowItem = this.rowItem;
      this.$refs.peoModal.userType = this.userType;
      this.$refs.peoModal.btnShow = this.btnShow;
      this.$refs.peoModal.beEnd = this.rowItem.beEnd;
      //   this.$refs.peoModal.getData()
    },
    addJob() {
      this.$refs.JobModal.id = this.id;
      this.$refs.JobModal.jobmodal = true;
      this.$refs.JobModal.nullJobSerialnumberList = [...this.modelData];
    },
    jobSave() {
      this.getData();
    },
    dirSearch() {
      this.$refs.DirModalComponent.modalShow = true;
    },
    dirSelect(item) {
      let json = JSON.parse(item);
      this.modalFormItem.dirSupName = json.userName;
      this.modalFormItem.dirSupSerialnumber = json.dirSupSerialnumber;
      this.$set(this.modalFormItem, "dirSupName", json.userName);
      this.levelDisabledState = false;
    },
    dirClear() {
      this.modalFormItem.dirSupSerialnumber = "";
      this.levelDisabledState = true;
    },
    beEndNameColor(val) {
      if (val == "未激活") return "cyan";
      else if (val == "待校准") return "green";
      else if (val == "校准中") return "orange";
      else if (val == "已结束") return "red";
    },
    peoSave(item) {
      this.getSessionData(item);
    },
    getSessionData(row) {
      this.item = JSON.parse(JSON.stringify(row));
      let obj = JSON.parse(JSON.stringify(row));
      obj.sendMailFlag ? (obj.sendMailFlag = "1") : (obj.sendMailFlag = "0");
      this.sessionLoading = true;
      axios
        .post("/TalentInventory/checkTalentAssess", {
          ...obj,
          ...this.pageInfo1,
        })
        .then((res) => {
          this.sessionLoading = false;
          if (res) {
            if (res.data.length > 0) {
              this.sessionModal = true;
              this.sessionData = res.data;
            } else {
              this.$refs.peoModal.saveTwo();
            }
            this.total1 = parseInt(res.pageInfo.total);
          }
        });
    },
    pageChange1(val) {
      this.pageInfo1.pageNo = val;
      this.getSessionData(this.item);
    },
    onSelectList(list) {
      this.getData();
    },
    deleteItem(row, index) {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          let obj = {
            id: this.id,
            userType: this.userType,
            ...row,
          };
          axios
            .post("/TalentInventory/deleteTalentInventoryUser", obj)
            .then((res) => {
              if (res) {
                this.$Message.success(res);
                this.getData();
              }
            });
        },
      });
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    handleReset() {
      this.modalFormItem = {
        dirSupName: "",
        levelNum: [],
      };
      this.$refs.UserGroupList.selectModalGroupList = [];
      this.$refs.UserGroupList.formItem.userGroupList = [];
      //   this.pageInfo.pageNo=1
      //   this.getData()
    },
  },
};
</script>

<style lang="less" scoped>
.hearderDiv {
  padding: 15px 10px 0 10px;
  background: #f5f5f5;
  width: 100%;
  margin-bottom: 35px;
}
.card {
  /deep/.ivu-form-item {
    margin-bottom: 0px !important;
  }
}
/deep/.ivu-card-body {
  background: rgb(231, 243, 231);
}
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/PeopleBoardSelectEmpJump.vue